import { ReactNode, useMemo } from 'react';

import { createCtx } from '@pletly/ui';
import { useInvitationsList } from './useInvitationsList';
import { useNewInvitationSubscription } from './useNewInvitationSubscription';

type ContextType = ReturnType<typeof useInvitationsList>;

const [useInvitations, InvitationsDataProvider] = createCtx<ContextType>();

const InvitationsProvider = ({ children }: { children?: ReactNode }) => {
	const { invitations, loading, error, refetch } = useInvitationsList();

	useNewInvitationSubscription(refetch);

	const value = useMemo(
		() => ({
			invitations,
			loading,
			error,
			refetch,
		}),
		[invitations, loading, error, refetch],
	);

	return <InvitationsDataProvider value={value}>{children}</InvitationsDataProvider>;
};

export { useInvitations, InvitationsProvider };
